export const CONFIG = {
    BACKEND: process.env.REACT_APP_BACKEND_URL || "",
    NETWORK: "Arc",
    SETTLEMENT: "USDC",
    X_URL: process.env.REACT_APP_X_URL || "https://x.com/VeraOnArc",
    ARGUS_URL: process.env.REACT_APP_ARGUS_URL || "https://argus.world",
    BUY_URL: process.env.REACT_APP_BUY_URL || process.env.REACT_APP_ARGUS_URL || "https://argus.world",
    DEXSCREENER_URL: process.env.REACT_APP_DEXSCREENER_URL || "",
    DEXSCREENER_HOME: "https://dexscreener.com",
    TOKEN_ADDRESS: process.env.REACT_APP_VERA_TOKEN_ADDRESS || "",
    REGISTRY_ADDRESS: process.env.REACT_APP_VERA_REGISTRY_ADDRESS || "",
    POOL_FACTORY_ADDRESS: process.env.REACT_APP_VERA_POOL_FACTORY_ADDRESS || "",
    VAULT_ADDRESS: process.env.REACT_APP_VERA_VAULT_ADDRESS || "",
    LOGO: "/assets/vera-logo.jpg",
    X_BANNER: "/assets/vera-x-banner.jpg",
    ARTICLE_BANNER: "/assets/vera-article-banner.jpg",
    OG_IMAGE: "/assets/vera-og.jpg",
};

export const OFFICIAL_STATUS = [
    { name: "PROTOCOL", status: "LIVE" },
    { name: "TOKEN", status: "LIVE" },
    { name: "ASSET LAYER", status: "BUILDING" },
    { name: "CAPITAL LAYER", status: "BUILDING" },
    { name: "ARC", status: "LIVE" },
];
